import { Component, Input } from "@angular/core";

@Component({
    selector: 'active-status',
    template: `
    <span class="badge text-uppercase"
          [ngClass]=" { 'badge-soft-success': isActive, 'badge-soft-danger': !isActive }">{{isActive ? 'Active' : 'Inactive'}}</span>
  `,
    standalone: false
})
export class ActiveStatusComponent {

  @Input('isActive') isActive: boolean = false;

}
